import type { ReactNode } from 'react';

export interface SurfaceCardProps {
  /** Título do card. */
  readonly title: ReactNode;
  /** Conteúdo do canto direito do header (contagem, ações). */
  readonly headerRight?: ReactNode;
  /** Descrição opcional exibida sob o título. */
  readonly description?: string;
  /** Conteúdo do corpo. O padding interno é responsabilidade de quem usa. */
  readonly children?: ReactNode;
  readonly className?: string;
}

/**
 * Card de seção da feature: header com divisor e corpo sem padding.
 *
 * O corpo recebe os filhos cru para permitir conteúdo full-bleed (tabela, gráfico)
 * sem margem lateral indesejada.
 */
export function SurfaceCard({
  title,
  headerRight,
  description,
  children,
  className,
}: SurfaceCardProps) {
  return (
    <section
      className={[
        'overflow-hidden rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface shadow-level1',
        className ?? '',
      ].join(' ')}
    >
      <div className="flex items-start justify-between gap-xxs border-b-hairline border-ctx-layout-border px-xxs py-mini">
        <div className="flex flex-col gap-quark">
          <span className="text-ctx-content-title ts-heading-xs">{title}</span>
          {description ? (
            <span className="text-ctx-content-placeholder ts-paragraph-xxs">{description}</span>
          ) : null}
        </div>
        {headerRight ? <div className="shrink-0">{headerRight}</div> : null}
      </div>
      {children}
    </section>
  );
}
